import { type Trait } from './types';

export const parseRecommendations: (traitName: string, trait?: Trait) => string[] = (
	traitName: string,
	trait?: Trait,
): string[] => {
	if (trait && trait.name === traitName && trait.value && typeof trait.value === 'string') {
		return trait.value.split(',').filter((s) => s.length > 0);
	}
	return [];
};
